import React, { memo } from 'react'

const SvgComponent = (props) => (
  <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1 0.535156L4.293 3.82815L8.07178 0.535156" stroke="#80506F" />
  </svg>
)

export default memo(SvgComponent)
